import _20250225173436_temp from '../migrations/20250225173436_temp/migration';
import _20250322043553_add_earliest_known_modified_at from '../migrations/20250322043553_add_earliest_known_modified_at/migration';
import _20250428155309_add_indexes from '../migrations/20250428155309_add_indexes/migration';
import _20250428160933_add_attributes from '../migrations/20250428160933_add_attributes/migration';
import _20250429042149_nested_projects from '../migrations/20250429042149_nested_projects/migration';
import _20250430052140_search_virtual_tables from '../migrations/20250430052140_search_virtual_tables/migration';
import _20250510163125_add_user_activity from '../migrations/20250510163125_add_user_activity/migration';
import _20250514213810_add_stars from '../migrations/20250514213810_add_stars/migration';
import _20250708193324_add_revisions from '../migrations/20250708193324_add_revisions/migration';
import _20250805014136_remove_user_email from '../migrations/20250805014136_remove_user_email/migration';
import _20250811165803_file_hashes_and_upload_experience from '../migrations/20250811165803_file_hashes_and_upload_experience/migration';
import _20250911155953_add_user_preferences from '../migrations/20250911155953_add_user_preferences/migration';
import _20250924041048_add_attachment_hidden_field from '../migrations/20250924041048_add_attachment_hidden_field/migration';
import _20251008024859_remove_file_revision_project_revision_id_field from '../migrations/20251008024859_remove_file_revision_project_revision_id_field/migration';

export const databaseVersion = 3;

export const migrations = [
    {
        name: '20250225173436_temp',
        migration: _20250225173436_temp,
    },
    {
        name: '20250322043553_add_earliest_known_modified_at',
        migration: _20250322043553_add_earliest_known_modified_at,
    },
    {
        name: '20250428155309_add_indexes',
        migration: _20250428155309_add_indexes,
    },
    {
        name: '20250428160933_add_attributes',
        migration: _20250428160933_add_attributes,
    },
    {
        name: '20250429042149_nested_projects',
        migration: _20250429042149_nested_projects,
    },
    {
        name: '20250430052140_search_virtual_tables',
        migration: _20250430052140_search_virtual_tables,
    },
    {
        name: '20250510163125_add_user_activity',
        migration: _20250510163125_add_user_activity,
    },
    {
        name: '20250514213810_add_stars',
        migration: _20250514213810_add_stars,
    },
    {
        name: '20250708193324_add_revisions',
        migration: _20250708193324_add_revisions,
    },
    {
        name: '20250805014136_remove_user_email',
        migration: _20250805014136_remove_user_email,
    },
    {
        name: '20250811165803_file_hashes_and_upload_experience',
        migration: _20250811165803_file_hashes_and_upload_experience,
    },
    {
        name: '20250911155953_add_user_preferences',
        migration: _20250911155953_add_user_preferences,
    },
    {
        name: '20250924041048_add_attachment_hidden_field',
        migration: _20250924041048_add_attachment_hidden_field,
    },
    {
        name: '20251008024859_remove_file_revision_project_revision_id_field',
        migration: _20251008024859_remove_file_revision_project_revision_id_field,
    },
];
